import { render, staticRenderFns } from "./ListResponsibilities.vue?vue&type=template&id=1b892605&"
import script from "./ListResponsibilities.vue?vue&type=script&lang=js&"
export * from "./ListResponsibilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports